/** Pestañas del editor de agente. Módulo mínimo (sin dependencias) para que el router no arrastre `draft.ts` al bundle inicial. */
export const AGENT_TABS = ['general', 'prompt', 'tools', 'flows', 'demo', 'versions', 'evals'] as const;
export type AgentTab = (typeof AGENT_TABS)[number];
